import { z } from "zod";

export const exportDestinationEnum = z.string();
export type ExportDestination = z.infer<typeof exportDestinationEnum>;

export interface ExportToolConfig {
  id: ExportDestination;
  name: string;
  description: string;
  enabled: boolean;
  requiresLinkedRepo: boolean;
  supportsBatch: boolean;
}

export const EXPORT_REGISTRY: ExportToolConfig[] = [];

export const projectExportConfigSchema = z.object({
  enabledTools: z.array(exportDestinationEnum).default([]),
});

export type ProjectExportConfig = z.infer<typeof projectExportConfigSchema>;
